import styled from 'styled-components';

export const Overlay = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 2002;
  position: fixed;
  top: 0;
  left: 0;
`;

export const OverlayMessage = styled.h3`
  color: #fff;
`;
